"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Text = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const THEME = {
  display: "font-serif font-700 text-1_75 leading-1_25 tracking-0_8 s768:text-2 s768:tracking-1",
  title: "font-serif font-700 text-1_5 leading-1_25 tracking-0_8",
  header: "font-400 text-1_25 leading-1_2 tracking-0_2",
  "header-md": "font-500 text-1_25 leading-1_2 tracking-0_2",
  subheader: "font-500 text-1 leading-1_5 tracking-0_2",
  body: "font-400 text-1 leading-1_5 tracking-0_2",
  "body-md": "font-500 text-1 leading-1_5 tracking-0_2",
  small: "font-400 text-0_875 leading-1_5 tracking-0_2",
  "small-md": "font-500 text-0_875 leading-1_5 tracking-0_2",
  tiny: "font-400 text-0_75 leading-1_5 tracking-0_2",
  "tiny-md": "font-500 text-0_75 leading-1_5 tracking-0_2"
};
const Text = /*#__PURE__*/_react.default.forwardRef((_ref, ref) => {
  let {
    as,
    children,
    variant = "body",
    className,
    ...props
  } = _ref;
  const Component = as || "div";
  return /*#__PURE__*/_react.default.createElement(Component, _extends({}, props, {
    className: (0, _classnames.default)(THEME[variant], className),
    ref: ref
  }), children);
});
exports.Text = Text;
Text.displayName = "Typography";